import { render, staticRenderFns } from "./MainComponent.vue?vue&type=template&id=74241bfa&scoped=true&"
import script from "./MainComponent.vue?vue&type=script&lang=js&"
export * from "./MainComponent.vue?vue&type=script&lang=js&"
import style0 from "./MainComponent.vue?vue&type=style&index=0&id=74241bfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74241bfa",
  null
  
)

export default component.exports